import matchValidate from "../../shared/match.validate";
import passwordLengthValidate from "../../shared/passwordLength.validate";

export type TErrors = {
  oldpassword: string | undefined;
  password: string | undefined;
  confirmpassword: string | undefined;
};

const updatePasswordValidate = (FormValues: Record<string, any>) => {
  let errors: TErrors = {
    oldpassword: undefined,
    password: undefined,
    confirmpassword: undefined,
  };

  errors.oldpassword = passwordLengthValidate(
    FormValues.oldpassword,
    "Old Password"
  );

  errors.password = passwordLengthValidate(FormValues.password, "Password");

  errors.confirmpassword = passwordLengthValidate(
    FormValues.confirmpassword,
    "Confirm Password"
  );

  errors.confirmpassword = matchValidate(
    FormValues.password,
    FormValues.confirmpassword
  );

  return errors;
};

export default updatePasswordValidate;
